import { Controller } from "@hotwired/stimulus"

// Loads a <turbo-frame loading="lazy"> early — when the frame is still
// 600px below the visible viewport — so paginated lists feel like
// continuous infinite scroll instead of stalling at every page boundary.
//
// Native loading="lazy" on a turbo-frame fires only when the frame element
// itself enters the viewport. With our fixed bottom nav covering the last
// ~80px of the screen, users routinely scroll until the last visible recipe
// looks final and stop, never bringing the trigger fully into view. This
// controller observes with a generous rootMargin and forces the load by
// removing the loading attribute the moment the trigger gets close.
export default class extends Controller {
  static values = { rootMargin: { type: String, default: "600px" } }

  connect() {
    if (typeof window.IntersectionObserver !== "function") {
      this.element.removeAttribute("loading")
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.element.removeAttribute("loading")
          this.observer.disconnect()
          break
        }
      }
    }, { rootMargin: this.rootMarginValue })

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
